<div class="relative inline-block z-[9999px] min-w-[1rem]">
  <!-- Trigger element -->
  <div
    class="cursor-pointer"
    (mouseenter)="showTooltip = true"
    (mouseleave)="showTooltip = false"
  >
    <ng-content></ng-content>
  </div>
 
  <!-- Tooltip -->
  <div *ngIf="showTooltip" [ngClass]="getTooltipClasses()" class="tooltipText">
    {{ text }}
 
    <!-- Arrow -->
    <div [ngClass]="getArrowClasses()" class="toolTipBgpointing"></div>
  </div>
</div>